import React, { Dispatch, SetStateAction } from 'react';
import { Trans } from '@lingui/macro';
import { Button, Dialog, Group } from '@economic/taco';

import date from '~/app/shared/util/utilities/date';
import PlanOption from '~/app/shared/components/PlanOption';
import ExternalLink from '~/app/shared/components/ExternalLink';
import { SmartPayOnboardingStatus, SMARTPAY_PLAN_OPTIONS } from '../../../types';

interface Props {
    currentPlan: 1 | 2;
    status: number;
    lastSubscriptionDate?: Date;
    planState: [number, Dispatch<SetStateAction<number>>];
    onNext: () => void;
    onBack: () => void;
}

const UpdatePlanStep = ({
    currentPlan,
    status,
    lastSubscriptionDate,
    onNext,
    onBack,
    planState: [selectedPlan, setSelectedPlan],
}: Props) => {
    return (
        <>
            <Dialog.Title>
                <div className="my-4">
                    <Trans>Change price plan</Trans>
                </div>
            </Dialog.Title>

            <div className="flex flex-col items-center">
                <span className="text-center">
                    {currentPlan === 1 ? (
                        <Trans>
                            You can easily switch between the price plans for Smart Pay. <br /> When you change to Smart Pay
                            Subscription, this will take effect immediately in accordance with our
                            <ExternalLink href="https://www.e-conomic.dk/abonnementsvilkaar-e-conomic">
                                subscription terms.
                            </ExternalLink>
                        </Trans>
                    ) : (
                        <Trans>
                            You can easily switch between the price plans for Smart Pay. <br /> When you switch, your current
                            Smart Pay Subscription will stop at the end of the quarter in accordance with our
                            <ExternalLink href="https://www.e-conomic.dk/abonnementsvilkaar-e-conomic">
                                subscription terms.
                            </ExternalLink>
                        </Trans>
                    )}
                </span>
                <div className="flex justify-around my-6">
                    {SMARTPAY_PLAN_OPTIONS.map(planDetails => (
                        <PlanOption
                            key={planDetails.id}
                            selected={selectedPlan === planDetails.id}
                            onSelect={() => setSelectedPlan(planDetails.id)}>
                            <div className="my-4 text-lg font-semibold h-12">{planDetails.name}</div>
                            <div className="my-4 text-lg">{planDetails.price}</div>
                            <div className="my-4">
                                {planDetails.features}
                                {status < SmartPayOnboardingStatus.Completed && planDetails.id === 2 && (
                                    <div className="mt-4 italic text-xs">
                                        <Trans>
                                            *payment of the subscription begins as soon as the Smart Pay account is active
                                        </Trans>
                                    </div>
                                )}

                                {/* if user have recently unsubscribed from SmartPay but plan is still active until the end of the quarter */}
                                {planDetails.id === 2 && currentPlan === 1 && lastSubscriptionDate && (
                                    <div className="mt-4 italic text-xs">
                                        <Trans>
                                            Subscription will be fully disabled on {date.format(lastSubscriptionDate)}. You can
                                            still use its benefits until then.
                                        </Trans>
                                    </div>
                                )}
                            </div>
                        </PlanOption>
                    ))}
                </div>
            </div>

            <Dialog.Footer>
                <Group>
                    <Button onClick={onBack}>
                        <Trans>Cancel</Trans>
                    </Button>
                    <Button
                        autoFocus
                        appearance="primary"
                        onClick={onNext}
                        disabled={selectedPlan === undefined || selectedPlan === null}>
                        <Trans>Continue</Trans>
                    </Button>
                </Group>
            </Dialog.Footer>
        </>
    );
};

export default UpdatePlanStep;
